export const DEFAULT_DURATION = {
    unit: 'day',
    value: 1
};

export const EMPTY_SCHEDULE = {
    dateTimeDuration: DEFAULT_DURATION,
    duration: '',
    durationSpecified: true,
    durationType: '',
    end: '',
    endTime: '',
    recurrenceRule: null,
    start: '',
    startTime: ''
};
